import React from 'react';
import './App.css';

function App() {
  const competencies = [
    '🌐 Full-stack web development',
    '📱 iOS development',
    '⚡ Process automation',
    '☁️ Cloud development',
    '🔄 CI/CD',
    '📊 Analytics'
  ];

  return (
    <div className="app">
      <div className="split-layout">
        <div className="logo-section">
          <img src="/logo.png" alt="Onkod Logo" className="main-logo" />
        </div>
        <main className="content-section">
          {/* <h1>Onkod</h1> */}
          <p className="description">
            We are a software consulting and development company focused on delivering
            high-quality solutions for our clients.
          </p>
          
          <section className="competencies">
            <h2>Our Expertise</h2>
            <ul>
              {competencies.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="contact">
            <a href="mailto:hello@onkod.io">👋 Say hi!</a>
          </section>
        </main>
      </div>
    </div>
  );
}

export default App; 